// extracted by mini-css-extract-plugin
export var underlinedLink = "_ty-0";